







import { defineComponent, PropType } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "ToggleCam",
  components: { BaseButton, BaseIcon },
  props: {
    constraints: { type: [Object, Boolean] as PropType<MediaTrackConstraints | boolean> },
  },
  setup(props, { emit }) {
    let lastConstraints: MediaTrackConstraints | boolean | undefined;
    const onClick = () => {
      emit("changeDevice", { video: props.constraints ? false : lastConstraints });
      lastConstraints = props.constraints;
    };
    return {
      onClick,
    };
  },
});
